import {
  call, put, takeEvery, all,
} from 'redux-saga/effects';
import { Record } from 'immutable';
import { getTableData, deleteItemsRequest, moveItemsRequest } from '../api';
import { appName } from '../constants';

/**
 * Constants
 * */
export const moduleName = 'etl_products';
const prefix = `${appName}/${moduleName}`;

export const TABLE_DATA_REQUEST = `${prefix}/TABLE_DATA_REQUEST`;
export const TABLE_DATA_SUCCESS = 'TABLE_DATA_SUCCESS';
export const TABLE_DATA_ERROR = 'TABLE_DATA_ERROR';

export const REMOVE_ITEM_REQUEST = `${prefix}/REMOVE_ITEM_REQUEST`;
export const REMOVE_ITEM_SUCCESS = 'REMOVE_ITEM_SUCCESS';
export const REMOVE_ITEM_ERROR = 'REMOVE_ITEM_ERROR';

export const MOVE_ITEM_REQUEST = `${prefix}/MOVE_ITEM_REQUEST`;
export const MOVE_ITEM_SUCCESS = 'MOVE_ITEM_SUCCESS';
export const MOVE_ITEM_ERROR = 'MOVE_ITEM_ERROR';

/**
 * Reducer
 * */

export const ReducerRecord = Record({
  loaded: false,
  loading: false,
  products: null,
  tableLoaded: true,
});

export default function reducer(state = new ReducerRecord(), action) {
  const { type, payload } = action;

  switch (type) {
    case TABLE_DATA_REQUEST:
      return state.set('loading', true).set('loaded', false);
    case TABLE_DATA_SUCCESS:
      return state
        .set('loading', false)
        .set('loaded', true)
        .set('products', payload);

    default:
      return state;
  }
}

/**
 * Selectors
 * */

export const productsSelector = (state) => state;

/**
 * Action Creators
 * */

// Getting products list
export const getProducts = (url) => ({
  payload: url,
  type: TABLE_DATA_REQUEST,
});

const productsToSuccess = (data) => ({ payload: data, type: TABLE_DATA_SUCCESS });

const productsWithError = (error) => ({ type: TABLE_DATA_ERROR, ...error });

// Removing items
export const deleteItems = (tableItems, currentPageLocation, scraper_id) => ({
  payload: {
    currentPageLocation,
    scraper_id,
    tableItems,
  },
  type: REMOVE_ITEM_REQUEST,
});

const deleteItemsToSuccess = (data) => ({ payload: data, type: REMOVE_ITEM_SUCCESS });

const deleteItemsWithError = (error) => ({ type: REMOVE_ITEM_ERROR, ...error });

// Removing items
export const moveItems = (tableItems, currentPageLocation, scraper_id) => ({
  payload: {
    currentPageLocation,
    scraper_id,
    tableItems,
  },
  type: MOVE_ITEM_REQUEST,
});

const moveItemsToSuccess = (data) => ({ payload: data, type: MOVE_ITEM_SUCCESS });

const moveItemsWithError = (error) => ({ type: MOVE_ITEM_ERROR, ...error });

/**
 * Sagas
 * */

function* productsData(action) {
  try {
    const result = yield call(() => getTableData(action.payload));

    yield put(productsToSuccess(result.data));
  } catch (error) {
    yield put(productsWithError(error));
  }
}

function* productsRemoveItem(action) {
  try {
    const result = yield call(() => deleteItemsRequest(`/etl/scrapers/${action.payload.scraper_id}/products?${action.payload.tableItems}`));
    yield put(deleteItemsToSuccess(result.data));
    yield put(getProducts(`/etl/scrapers/${action.payload.scraper_id}/products${action.payload.currentPageLocation}`));
  } catch (error) {
    yield put(deleteItemsWithError(error));
  }
}

function* productsMoveItem(action) {
  try {
    const result = yield call(() => moveItemsRequest(`/etl/scrapers/${action.payload.scraper_id}/move_selected_products?${action.payload.tableItems}`));
    yield put(moveItemsToSuccess(result.data));
    yield put(getProducts(`/etl/scrapers/${action.payload.scraper_id}/products${action.payload.currentPageLocation}`));
  } catch (error) {
    yield put(moveItemsWithError(error));
  }
}

export function* saga() {
  yield all([takeEvery(TABLE_DATA_REQUEST, productsData),
    takeEvery(REMOVE_ITEM_REQUEST, productsRemoveItem),
    takeEvery(MOVE_ITEM_REQUEST, productsMoveItem)]);
}
